module.exports = __webpack_public_path__ + "static/media/img-company-success@2x.1393f915.png";